module.exports = __webpack_public_path__ + "img/yj40-04a.prt.9817d6d5.jpg";